export default __webpack_public_path__ + "703a719252a8bc5522e44e09da80866e.svg";